import * as t from '../actionTypes'
import axios from 'utils/axios'
import { guardFromErrors, extractErrorInfo } from 'utils/graphqlHelpers'

export type RemoveSendgridSettingAction = FSA<undefined, number, string>
type RemoveSendgridSettingColor = (sendgridSettingId: number) => MrxThunk<RemoveSendgridSettingAction, Promise<boolean>>
type QueryResponse = GraphQLResponse<'removeSendgridSetting', boolean>

const REMOVE_SENDGRID_SETTING = `
  mutation removeSendgridSetting ($sendgridSettingId: Int!) {
    removeSendgridSetting(sendgridSettingId: $sendgridSettingId)
  }
`

const removeSendgridSetting: RemoveSendgridSettingColor = (sendgridSettingId) => async (dispatch) => {
  let isRemoved = false

  dispatch({
    type: t.REMOVE_SENDGRID_SETTING,
    meta: { done: false }
  })

  try {
    const {
      data: { data, errors }
    }: QueryResponse = await axios.post('/graphql', {
      query: REMOVE_SENDGRID_SETTING,
      variables: { sendgridSettingId }
    })

    guardFromErrors(errors)

    if (!data) {
      throw new Error('Empty response!')
    }

    const { removeSendgridSetting } = data
    if (!removeSendgridSetting) {
      throw new Error("Can't remove sendgrid setting!")
    }

    dispatch({
      type: t.REMOVE_SENDGRID_SETTING,
      payload: sendgridSettingId,
      meta: { done: true }
    })

    isRemoved = true
  } catch (err) {
    dispatch({
      type: t.REMOVE_SENDGRID_SETTING,
      payload: extractErrorInfo(err),
      error: true
    })
  }

  return isRemoved
}

export { removeSendgridSetting }
